import useSelectionState from "../../../contexts/selection-state/SelectionStateContext";
import { DashboardTicketState, useAddTicketStateIdMutation } from "../../../__generated__/api";
import { useRegisterAction } from "../../../contexts/ticket-state";
import useLogging from "../../../contexts/logging/LoggingContext";
import { ActionType, HANDLER_INTERFACE } from "../../../contexts/ticket-state/action-registry";

export default function SetTicketState(): null {
    const selectionState = useSelectionState();
    const [addState] = useAddTicketStateIdMutation();
    const logging = useLogging();

    const setState = async (ids: string[], state: DashboardTicketState): Promise<void> => {
        await addState({
            variables: {
                chatIds: ids,
                stateId: state.ticketStateId,
            },
        });
    };

    useRegisterAction({
        handleBulkAction(handler) {
            logging.wrap(async () => {
                const groups = handler.items.groupBy(item => item.ticketStateId);
                handler.done();
                Object.values(groups).forEachConcurrent(async group => {
                    await addState({
                        variables: {
                            chatIds: group.toIdList("id"),
                            stateId: group.firstElement.ticketStateId,
                        },
                    });
                });
            });
        },
    }, ActionType.STORE_TICKET_COLUMN);

    selectionState?.registerSetChatStateHandler(setState);

    return null;
}

HANDLER_INTERFACE.register(SetTicketState);
